import { css } from '@emotion/css';

export const radioGroupCx = (orientation: 'row' | 'column') => css`
  &.MuiFormGroup-root {
    flex-direction: ${orientation};
  }
`;
